import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import React, { Suspense, useState, useCallback } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

// 创建一个带重试功能的 lazy loader
const createLazyEditor = () => {
  return /*#__PURE__*/React.lazy(() => import('./RealEditor').then(m => ({
    default: m.WangEditor
  })).catch(error => {
    // 如果是 chunk 加载错误，抛出特殊错误以便识别
    if (error?.name === 'ChunkLoadError' || error?.message?.includes('chunk')) {
      const chunkError = new Error('CHUNK_LOAD_ERROR');
      chunkError.name = 'ChunkLoadError';
      throw chunkError;
    }

    throw error;
  }));
}; // 错误回退组件


const EditorErrorFallback = ({
  error
}) => {
  const isChunkError = error?.name === 'ChunkLoadError' || error?.message?.includes('chunk');
  const handleRetry = useCallback(() => {
    // 清除可能的缓存
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    } // 重新加载页面以重新获取 chunk


    window.location.reload();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 40,
      textAlign: 'center',
      border: '1px solid #ccc',
      borderRadius: 4,
      backgroundColor: '#fff'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 16,
      color: '#f53f3f'
    }
  }, isChunkError ? '编辑器资源加载失败' : '编辑器加载出错'), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 16,
      color: '#86909c',
      fontSize: 12
    }
  }, isChunkError ? '可能是网络问题导致资源下载失败，请点击重试按钮' : error?.message || '未知错误'), /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    onClick: handleRetry
  }, "\u91CD\u8BD5\u52A0\u8F7D"));
};

export const WangEditor = props => {
  const [retryCount, setRetryCount] = useState(0);
  const [LazyEditor, setLazyEditor] = useState(() => createLazyEditor());
  const handleReset = useCallback(() => {
    // 重新创建 lazy component 以触发重新加载
    setLazyEditor(() => createLazyEditor());
    setRetryCount(prev => prev + 1);
  }, []);
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    FallbackComponent: EditorErrorFallback,
    onReset: handleReset,
    resetKeys: [retryCount],
    onError: (error, errorInfo) => {
      // 记录错误信息
      console.error('WangEditor chunk load error:', error, errorInfo);

      if (error?.name === 'ChunkLoadError' || error?.message?.includes('chunk')) {
        _Message.error('编辑器资源加载失败，请刷新页面重试');
      }
    }
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", {
      style: {
        padding: 20,
        textAlign: 'center',
        border: '1px solid #ccc',
        borderRadius: 4,
        backgroundColor: '#fff'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: 8
      }
    }, "\u6B63\u5728\u52A0\u8F7D\u7F16\u8F91\u5668..."), /*#__PURE__*/React.createElement("div", {
      style: {
        color: '#86909c',
        fontSize: 12
      }
    }, "\u9996\u6B21\u52A0\u8F7D\u53EF\u80FD\u9700\u8981\u4E00\u4E9B\u65F6\u95F4"))
  }, /*#__PURE__*/React.createElement(LazyEditor, props)));
};